import React from 'react';
import {NavLink} from 'react-router-dom';
import AppBar from 'react-toolbox/lib/app_bar/AppBar';
import Navigation from 'react-toolbox/lib/navigation/Navigation';
import Drawer from 'react-toolbox/lib/drawer/Drawer';
import List from 'react-toolbox/lib/list/List';
import ListItem from 'react-toolbox/lib/list/ListItem';
import ListDivider from 'react-toolbox/lib/list/ListDivider';
import styled from 'styled-components';
import logo from '../images/siv.logo.png';

const StyledLink = styled(NavLink)`
    margin: auto 5px;
`;

const PlainTextLink = styled(NavLink)`
    text-decoration: none;
`;

const StyledDrawer = styled(Drawer)`
    max-width: 200px;
`;

const LogoImage = styled.img`
  width: 80%;
  display: block;
  margin: 20px auto;
`;

export default class Header extends React.PureComponent {
    state = {
        opened: false
    };

    handleDrawerToggle = () => {
        this.setState({opened: !this.state.opened});
    };

    render() {
        return (
            <React.Fragment>
                <AppBar className='horizontal-navigation' title='SIVCLINIC.COM' flat fixed scrollHide>
                    <Navigation className='large-screen' type='horizontal'>
                        <StyledLink to='/about-us'>about</StyledLink>
                        <StyledLink to='/reviews'>reviews</StyledLink>
                        <StyledLink to='/sites'>launches</StyledLink>
                        <StyledLink to='/tandem-flights'>tandem</StyledLink>
                        <StyledLink to='/travel-tours'>colombia</StyledLink>
                        <StyledLink to='/siv-clinics'>siv</StyledLink>
                        <StyledLink to='/payments'>pay</StyledLink>
                        <StyledLink to='/contact'>contact</StyledLink>
                    </Navigation>
                </AppBar>

                <AppBar className='vertical-navigation' title='SIVCLINIC.COM' leftIcon='menu' flat
                        onLeftIconClick={this.handleDrawerToggle}>
                    <StyledDrawer className='small-screen' active={this.state.opened}
                                  onOverlayClick={this.handleDrawerToggle}>
                        <LogoImage src={logo}/>
                        <Navigation type='vertical'>
                            <List selectable ripple>
                                <ListDivider/>
                                <PlainTextLink to='/about-us' onClick={this.handleDrawerToggle}>
                                    <ListItem leftIcon='star' caption='about us'/>
                                </PlainTextLink>
                                <ListDivider/>
                                <PlainTextLink to='/reviews' onClick={this.handleDrawerToggle}>
                                    <ListItem leftIcon='thumb_up' caption='reviews'/>
                                </PlainTextLink>
                                <ListDivider/>
                                <PlainTextLink to='/sites' onClick={this.handleDrawerToggle}>
                                    <ListItem leftIcon='insert_photo' caption='launches'/>
                                </PlainTextLink>
                                <ListDivider/>
                                <PlainTextLink to='/tandem-flights' onClick={this.handleDrawerToggle}>
                                    <ListItem leftIcon='group' caption='tandem'/>
                                </PlainTextLink>
                                <ListDivider/>
                                <PlainTextLink to='/travel-tours' onClick={this.handleDrawerToggle}>
                                    <ListItem leftIcon='filter_drama' caption='colombia'/>
                                </PlainTextLink>
                                <ListDivider/>
                                <PlainTextLink to='/siv-clinics' onClick={this.handleDrawerToggle}>
                                    <ListItem leftIcon='school' caption='siv clinics'/>
                                </PlainTextLink>
                                <ListDivider/>
                                <PlainTextLink to='/payments' onClick={this.handleDrawerToggle}>
                                    <ListItem leftIcon='payment' caption='easy pay'/>
                                </PlainTextLink>
                                <ListDivider/>
                                <PlainTextLink to='/contact' onClick={this.handleDrawerToggle}>
                                    <ListItem leftIcon='textsms' caption='contact'/>
                                </PlainTextLink>
                                <ListDivider/>
                            </List>
                        </Navigation>
                    </StyledDrawer>
                </AppBar>
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/Header.js